import { render, staticRenderFns } from "./CreateAdDiscount.vue?vue&type=template&id=13c2c248&"
import script from "./CreateAdDiscount.vue?vue&type=script&lang=js&"
export * from "./CreateAdDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports